module.exports = __webpack_public_path__ + "components/flag/static/square/ni-e4f79630ef8e56ecd7110b6888ed9c8b.svg";